import React, { useContext, useEffect, useState } from "react";
import DropDown from "../TPDropDown";
import { useTranslation } from "react-i18next";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import {
  SOURCE_TYPE,
  CONSTANT_RECORD_TYPE,
  ACTIONS,
  INDEX,
  SYSTEM_SOURCE_NAME,
  IB_SOURCE_NAME,
} from "../../../constants/loopRecordOptions";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Tab,
  Tabs,
  Select,
  Autocomplete,
  TextField,
  Button,
  Stack,
} from "@mui/material";
import { api } from "../../../redux/api";
import { useDispatch, useSelector } from "react-redux";
import { cloneDeep } from "lodash";
import WorkflowSessionModal1 from "../../ItemProperties/WorkflowSessionModal1";
import { ParentScreenCtx } from "../../../pages/workbench_build/WorkbenchBuild";

const SourceTypeSystemData = ({ node, sourceType, valuesHandler, includeTrailer, callerComponent, disabled }) => {
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx);
  const [sourceItem, setSourceItem] = useState("CUSTOM_DB_FIELD");
  const [sourceValue, setSourceValue] = useState(t('SELECT'));
  const [sourceOption, setSourceOption] = useState([
    { value: t("SELECT"), title: t("SELECT") },
  ]);
  const [sessionValue, setSessionValue] = useState('');
  const [workflowSessionModal, setWorkflowSessionModal] = useState(false);
  const { account } = useSelector(state => state?.queryParams || {});
  const tree = useSelector(state => state.treeData.outbound.rightTree.tree);
  const inboundDependencyTree = useSelector(state => state.treeData.outbound.leftTree.inboundDependencyTree);
  const dispatch = useDispatch();
  const [constantValue, setConstantValue] = useState('')
  const systemItemsOptionArray = [{ title: t('SELECT'), value: 'SELECT' }, ...CONSTANT_RECORD_TYPE.SYSTEM_ITEM, ...(callerComponent === 'recordProperties' ? [{ title: t('CONSTANT'), value: 'CONSTANT' }] : [])]

  const systemItemsOption = systemItemsOptionArray.map(
    (ele, index) => {
      return (
        <MenuItem key={index} value={ele.value}>
          {ele.title}
        </MenuItem>
      );
    }
  );



  const getLoopAndSegmentCount = (value) => {
    const header = tree?.header?.translatedData || [];
    const body = tree?.body?.translatedData || [];
    const trailer = tree?.trailer?.translatedData || [];
    const returnedData = [];
    const loopData = (data = []) => {
      data.forEach((e) => {
        if (value === "LOOP_COUNT" && e?.LOOP_COUNT)
          returnedData.push(e.DESCRIPTION);
        else if (
          ["GLOBAL_SEGMENT_COUNT", "SEGMENT_COUNT"].includes(value) &&
          ["RECORD_LOOP", "RECORD", "FIELD_GROUP"].includes(e?.ICON_DISPLAY) &&
          e?.DESCRIPTION?.trim()?.startsWith("ST")
        ) {
          returnedData.push(e.DESCRIPTION);
        }
        if (e?.children.length) loopData(e.children);
      });
    };

    loopData(header);
    loopData(body);
    if (includeTrailer || tree.currentTab === "trailer") loopData(trailer);

    return returnedData;
  };

  const sourceNameHandler = (value, sourceValue) => {
    if (SYSTEM_SOURCE_NAME[value]) {
      const options = [...SYSTEM_SOURCE_NAME[value]]
      setSourceOption(options);
    }
    else if (['LOOP_COUNT', 'GLOBAL_SEGMENT_COUNT', 'SEGMENT_COUNT'].includes(value)) {
      const items = getLoopAndSegmentCount(value);
      items.unshift(t('SELECT'));
      
      setSourceOption(items.map((ele) => ({ value: ele, title: ele })));
      if (items?.includes(sourceValue)) setSourceValue(sourceValue);
      else setSourceValue(t('SELECT'));
    }
    else if (['ACCOUNT_KEYS', 'TRADING_PARTNER_KEYS'].includes(value)) {
      const apiEndpoints = {
        'ACCOUNT_KEYS': api.endpoints.getAccountData,
        'TRADING_PARTNER_KEYS': api.endpoints.getTradingPartnersKeys
      }
      dispatch(apiEndpoints?.[value]?.initiate({
        account
      }, { forceRefetch: true }))
        .then(res => {
          if (res.data.current_state === "SUCCESS") {
            let data;

            if (res?.data?.data?.account_data_keys) {
              data = res?.data?.data?.account_data_keys.map(
                (o) => Object?.keys(o)?.[0]
              );
            } else if (res?.data?.data?.trading_partner_keys) {
              data = res?.data?.data?.trading_partner_keys;
            }
            if (data) {
              const newData = [t("SELECT"), ...data];
              const options = newData.map((opt, idx) => ({
                key: `${opt}-${idx}`,
                value: opt,
                label: opt
              }))
              setSourceOption(options);
              setSourceValue(sourceValue);
            }
          }
        })
    } else {
      setSourceOption([{ value: t("SELECT"), title: t("SELECT") }]);
      setConstantValue(sourceValue)
    }
  };

  useEffect(() => {
    if (sourceType === "SYSTEM_ITEM") {
      const sourceItemValue = [...CONSTANT_RECORD_TYPE.SYSTEM_ITEM, ...(callerComponent === 'recordProperties' ? [{ title: t('CONSTANT'), value: 'CONSTANT' }] : [])]?.filter(
        (e) =>
          e?.value === node?.RECORD_TYPE || e?.value === node?.SOURCE_TYPE
      )?.length
        ? node?.RECORD_TYPE || node?.SOURCE_TYPE
        : "SYSTEM_DATA"
      const currSourceValue = SYSTEM_SOURCE_NAME.SYSTEM_DATA?.filter(
        (e) =>
          e?.value === node?.MAPNAME || e?.value === node?.LOOP_SOURCE_NAME
      )?.length
        ? sourceValue
        : t("SELECT");
      setSourceItem(sourceItemValue);
      // Ensure the source name control updates correctly when the node changes
      setSourceValue(node?.MAPNAME || node?.LOOP_SOURCE_NAME || t("SELECT"));
    }
  }, [node?.key])

  useEffect(() => {
    const sourceItemValue = [...CONSTANT_RECORD_TYPE.SYSTEM_ITEM, ...(callerComponent === 'recordProperties' ? [{ title: t('CONSTANT'), value: 'CONSTANT' }] : [])]?.filter(
      (e) =>
        e?.value === sourceItem
    )?.length
      ? sourceItem
      : "SYSTEM_DATA";
    const extraItems = ((tree.templateHeader?.FILETYPE === "HL7" || tree.templateHeader?.FILETYPE === "EDI") && sourceItemValue === "SYSTEM_DATA") ? [
      { label: t('OUT_FIELD_DELIMITER'), value: 'OUT_FIELD_DELIMITER', key: 'OUT_FIELD_DELIMITER' },
      { label: t('IN_FIELD_DELIMITER'), value: 'IN_FIELD_DELIMITER', key: 'IN_FIELD_DELIMITER' },
      { label: t('OUT_GROUP_COMP_DELIMITER'), value: 'OUT_GROUP_COMP_DELIMITER', key: 'OUT_GROUP_COMP_DELIMITER' },
      { label: t('OUT_ESCAPE_DELIMITER'), value: 'OUT_ESCAPE_DELIMITER', key: 'OUT_ESCAPE_DELIMITER' },
      { label: t('OUT_REPETITION_DELIMITER'), value: 'OUT_REPETITION_DELIMITER', key: 'OUT_REPETITION_DELIMITER' },
      { label: t('OUT_COMP_DELIMITER'), value: 'OUT_COMP_DELIMITER', key: 'OUT_COMP_DELIMITER' },
      { label: t('HL7_ENCODING_CHARACTERS'), value: 'HL7_ENCODING_CHARACTERS', key: 'HL7_ENCODING_CHARACTERS' },

    ] : [];
    if(tree?.templateHeader?.FILETYPE ==="DELIM_FLD_ID") {
      extraItems.push({ label: t('OUT_FIELD_DELIMITER'), value: 'OUT_FIELD_DELIMITER', key: 'OUT_FIELD_DELIMITER' });
      extraItems.push({ label: t('OUT_GROUP_COMP_DELIMITER'), value: 'OUT_GROUP_COMP_DELIMITER', key: 'OUT_GROUP_COMP_DELIMITER' });
    }
    const currSourceValue = [...(SYSTEM_SOURCE_NAME?.[sourceItemValue] || []), ...extraItems]?.filter(
      (e) =>
        e?.value === node?.MAPNAME || e?.value === node?.LOOP_SOURCE_NAME
    )?.length
      ? node?.MAPNAME || node?.LOOP_SOURCE_NAME 
      : "SELECT";
    if (sourceItem === "SESSION_DATA") setSessionValue(node?.MAPNAME || node?.LOOP_SOURCE_NAME);
    else if (['ACCOUNT_KEYS', 'TRADING_PARTNER_KEYS', 'LOOP_COUNT', 'GLOBAL_SEGMENT_COUNT', 'SEGMENT_COUNT', 'CONSTANT'].includes(sourceItem)) {
      sourceNameHandler(sourceItem, node?.MAPNAME || node?.LOOP_SOURCE_NAME);
    }
    else setSourceValue(currSourceValue)
    if (['ACCOUNT_KEYS', 'TRADING_PARTNER_KEYS', 'SESSION_DATA', 'LOOP_COUNT', 'GLOBAL_SEGMENT_COUNT', 'SEGMENT_COUNT', 'CONSTANT'].includes(sourceItem)) return;

    const options = SYSTEM_SOURCE_NAME[sourceItemValue].map((ele, idx) => ({
      key: `${ele}-${idx}`,
      value: ele.value,
      label: ele.title,
    }));
      if(tree?.templateHeader?.FILETYPE ==="DELIM_FLD_ID") {
        options.splice(20, 0, { label: t('OUT_FIELD_DELIMITER'), value: 'OUT_FIELD_DELIMITER', key: 'OUT_FIELD_DELIMITER' });
        options.splice(21, 0, { label: t('OUT_GROUP_COMP_DELIMITER'), value: 'OUT_GROUP_COMP_DELIMITER', key: 'OUT_GROUP_COMP_DELIMITER' });
      }
      if (tree.templateHeader?.FILETYPE === "HL7" && sourceItemValue === "SYSTEM_DATA") {
        options.splice(6, 0, { label: t('IN_FIELD_DELIMITER'), value: 'IN_FIELD_DELIMITER', key: 'IN_FIELD_DELIMITER' });
        options.splice(20, 0, { label: t('OUT_FIELD_DELIMITER'), value: 'OUT_FIELD_DELIMITER', key: 'OUT_FIELD_DELIMITER' });
        options.splice(23, 0, { label: t('OUT_GROUP_COMP_DELIMITER'), value: 'OUT_GROUP_COMP_DELIMITER', key: 'OUT_GROUP_COMP_DELIMITER' });
        options.splice(24, 0, { label: t('OUT_ESCAPE_DELIMITER'), value: 'OUT_ESCAPE_DELIMITER', key: 'OUT_ESCAPE_DELIMITER' },);
        options.splice(22, 0, { label: t('OUT_REPETITION_DELIMITER'), value: 'OUT_REPETITION_DELIMITER', key: 'OUT_REPETITION_DELIMITER' });
        options.splice(17, 0, { label: t('OUT_COMP_DELIMITER'), value: 'OUT_COMP_DELIMITER', key: 'OUT_COMP_DELIMITER' });
        options.push({ label: t('HL7_ENCODING_CHARACTERS'), value: 'HL7_ENCODING_CHARACTERS', key: 'HL7_ENCODING_CHARACTERS' });
      }
      if (tree.templateHeader?.FILETYPE === "EDI" && sourceItemValue === "SYSTEM_DATA") {
        options.splice(6, 0, { label: t('IN_FIELD_DELIMITER'), value: 'IN_FIELD_DELIMITER', key: 'IN_FIELD_DELIMITER' });
        options.splice(20, 0, { label: t('OUT_FIELD_DELIMITER'), value: 'OUT_FIELD_DELIMITER', key: 'OUT_FIELD_DELIMITER' });
        options.splice(23, 0, { label: t('OUT_GROUP_COMP_DELIMITER'), value: 'OUT_GROUP_COMP_DELIMITER', key: 'OUT_GROUP_COMP_DELIMITER' });
        options.splice(22, 0, { label: t('OUT_REPETITION_DELIMITER'), value: 'OUT_REPETITION_DELIMITER', key: 'OUT_REPETITION_DELIMITER' });
      }
      if(inboundDependencyTree?.templateHeader?.FILETYPE === "HL7" && sourceItemValue === "SYSTEM_DATA") {
        options.splice(6, 0, { label: t('IN_GROUP_COMP_DELIMITER'), value: 'IN_GROUP_COMP_DELIMITER', key: 'IN_GROUP_COMP_DELIMITER' });
        options.splice(7, 0, { label: t('IN_ESCAPE_DELIMITER'), value: 'IN_ESCAPE_DELIMITER', key: 'IN_ESCAPE_DELIMITER' });
        options.splice(8, 0, { label: t('IN_REPETITION_DELIMITER'), value: 'IN_REPETITION_DELIMITER', key: 'IN_REPETITION_DELIMITER' });
        options.splice(9, 0, { label: t('IN_COMP_DELIMITER'), value: 'IN_COMP_DELIMITER', key: 'IN_COMP_DELIMITER' });
      }
      if(inboundDependencyTree?.templateHeader?.FILETYPE === "EDI" && sourceItemValue === "SYSTEM_DATA") {
        options.splice(6, 0, { label: t('IN_REPETITION_DELIMITER'), value: 'IN_REPETITION_DELIMITER', key: 'IN_REPETITION_DELIMITER' });
      }
    setSourceOption(options);
    
  }, [sourceItem])

  useEffect(() => {
    const sourceItemValue = [...CONSTANT_RECORD_TYPE.SYSTEM_ITEM, ...(callerComponent === 'recordProperties' ? [{ title: t('CONSTANT'), value: 'CONSTANT' }] : [])]?.filter(
      (e) =>
        e?.value === node?.RECORD_TYPE || e?.value === node?.SOURCE_TYPE
    )?.length
      ? node?.RECORD_TYPE || node?.SOURCE_TYPE
      : "SYSTEM_DATA"

    if(inboundDependencyTree?.templateHeader?.FILETYPE !== "HL7" && sourceItemValue === "SYSTEM_DATA") {
      const removeItems = ["IN_GROUP_COMP_DELIMITER", "IN_ESCAPE_DELIMITER", "IN_COMP_DELIMITER"];
      if(inboundDependencyTree?.templateHeader?.FILETYPE !== "EDI") removeItems.push("IN_REPETITION_DELIMITER");
      setSourceOption(sourceOption.filter(e => !removeItems.includes(e.value)))
    } else if(inboundDependencyTree?.templateHeader?.FILETYPE === "HL7" && sourceItemValue === "SYSTEM_DATA" && !sourceOption.some(e => e.value === "IN_GROUP_COMP_DELIMITER")) {
      const newOptions = [...sourceOption];
      newOptions.splice(6, 0, { label: t('IN_GROUP_COMP_DELIMITER'), value: 'IN_GROUP_COMP_DELIMITER', key: 'IN_GROUP_COMP_DELIMITER' });
      newOptions.splice(7, 0, { label: t('IN_ESCAPE_DELIMITER'), value: 'IN_ESCAPE_DELIMITER', key: 'IN_ESCAPE_DELIMITER' });
      newOptions.splice(8, 0, { label: t('IN_REPETITION_DELIMITER'), value: 'IN_REPETITION_DELIMITER', key: 'IN_REPETITION_DELIMITER' });
      newOptions.splice(9, 0, { label: t('IN_COMP_DELIMITER'), value: 'IN_COMP_DELIMITER', key: 'IN_COMP_DELIMITER' });
      setSourceOption(newOptions);
    }
  }, [inboundDependencyTree]);

  return (
    <Stack sx={{ marginTop: "0px !important" }} spacing={"10px"}>
      <DropDown
        disabled={disabled}
        label={parentScreen === "workflow" ? t("LBL_SOURCE_RECORD_NAME") : t("LBL_SOURCE_ITEM")}
        options={systemItemsOption || []}
        value={
          systemItemsOption.filter((e) => e.props.value === sourceItem).length
            ? sourceItem
            : ""
        }
        onChange={(e) => {
          valuesHandler({
            MAPNAME: e.target.value === "CONSTANT" ? "" : t("SELECT"),
            RECORD_TYPE: e.target.value,
          }, "SYSTEM_ITEM");
          setTimeout(() => {
            sourceNameHandler(e.target.value);
            setSourceItem(e.target.value);
          });
        }}
      />
      {sourceItem === "SESSION_DATA" ? (
        <>
          <FormControl variant="outlined" className="width-100" size="small">
            <div className="flex">
              <FormControl className="width-100" size="small">
                <Autocomplete
                  disabled={disabled}
                  size="small"
                  variant="outlined"
                  className="width-100"
                  freeSolo
                  options={[]}
                  value={t(sessionValue) || ''}
                  inputValue={t(sessionValue) || ''}
                  onChange={(event, newValue) => {
                    setSessionValue(newValue?.label || "");
                    valuesHandler({
                      RECORD_TYPE: "SESSION_DATA",
                      MAPNAME: newValue?.label,
                    }, "SYSTEM_ITEM")
                  }}
                  onInputChange={(event, newInputValue) => {
                    setSessionValue(newInputValue);
                    valuesHandler({
                      RECORD_TYPE: "SESSION_DATA",
                      MAPNAME: newInputValue,
                    }, "SYSTEM_ITEM")
                  }}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      variant="outlined"
                      {...params}
                      value={sessionValue || ""}
                    />
                  )}
                />
              </FormControl>
              <Button
                disabled={disabled}
                variant="outlined"
                size="small"
                disableElevation
                className="margin-left-4"
                sx={{
                  width: "40px",
                  padding: "4px 8px",
                  minWidth: "40px",
                }}
                onClick={() => setWorkflowSessionModal(true)}
              >
                <MoreHorizIcon fontSize="small" />
              </Button>
            </div>
          </FormControl>
        </>
      ) : sourceItem === "CONSTANT" ? (
        <TextField
          disabled={disabled}
          type="text"
          size='small'
          label={t('LBL_CONST_VAL')}
          value={constantValue}
          onChange={(e) => {
            setConstantValue(e.target.value);
            valuesHandler({
              RECORD_TYPE: sourceItem,
              MAPNAME: e.target.value,
            }, "SYSTEM_ITEM");
          }}></TextField>
      ) : ["ACCOUNT_KEYS", "TRADING_PARTNER_KEYS"].includes(sourceItem) ? (
        <Autocomplete
          disabled={disabled}
          size="small"
          variant="outlined"
          className="width-100"
          sx={{ flexGrow: 1, minWidth: "140px" }}
          freeSolo
          options={(sourceOption || []).sort((a, b) => a?.label?.localeCompare(b?.label))}
          value={
            typeof sourceValue === "string"
              ? sourceValue
              : sourceValue?.value || ""
          }
          getOptionLabel={(option) =>
            typeof option === "string" ? option : option.label || ""
          }
          onChange={(e, newValue) => {
            if (typeof newValue === "string") {
              setSourceValue(newValue);
              valuesHandler(
                {
                  RECORD_TYPE: sourceItem,
                  MAPNAME: newValue,
                },
                "SYSTEM_ITEM"
              );
            } else {
              setSourceValue(newValue?.value);
              valuesHandler(
                {
                  RECORD_TYPE: sourceItem,
                  MAPNAME: newValue?.value || "",
                },
                "SYSTEM_ITEM"
              );
            }
          }}
          onInputChange={(e, newInputValue) => {
            setSourceValue(newInputValue);
            valuesHandler(
              {
                RECORD_TYPE: sourceItem,
                MAPNAME: newInputValue,
              },
              "SYSTEM_ITEM"
            );
          }}
          renderInput={(params) => (
            <TextField

              size="small"
              label={parentScreen === "workflow" ? t("LBL_SOURCE_FIELD_NAME") : t("LBL_SOURCE_NAME")}
              variant="outlined"
              {...params}
            />
          )}
        />
      ) : (sourceItem === "SELECT" || sourceItem === t("SELECT")) ? <> </> :(
        <DropDown
          disabled={disabled}
          label={parentScreen === "workflow" ? t("LBL_SOURCE_FIELD_NAME") : t("LBL_SOURCE_NAME")}
          options={(sourceOption || []).sort((a, b) => a?.label?.localeCompare(b?.label)).map((option, idx) => (
            <MenuItem key={`${idx}-${option.value}`} value={option.value}>
              {option.label || option.title}
            </MenuItem>
          ))}
          value={
            (sourceOption || []).some((e) => e?.value === sourceValue)
              ? sourceValue
              : t("SELECT")
          }
          onChange={(e) => {
            setSourceValue(e.target.value);
            valuesHandler(
              {
                RECORD_TYPE: sourceItem,
                MAPNAME: e.target.value,
              },
              "SYSTEM_ITEM"
            );
          }}
        />
      )}
      <WorkflowSessionModal1
        sourceType={'callingWorkflow'}
        openModal={workflowSessionModal}
        handleClose={setWorkflowSessionModal}
        valueHandler={([value]) => {
          valuesHandler({
            RECORD_TYPE: "SESSION_DATA",
            MAPNAME: value?.MAPNAME || '',
            WF_ITEM_ID: value?.WF_ITEM_ID,
            WF_ITEM_LOCATION: value?.WF_ITEM_LOCATION
          }, "SYSTEM_ITEM")
          setSessionValue(value?.MAPNAME || '');
        }}
        selection={"single"}
      />
    </Stack>
  );
};

export default SourceTypeSystemData;
